import type { ErrorInfo, ReactNode } from "react";
import React, { Component } from "react";
import ErrorState from "components/Error/ErrorState";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class PreviewErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Preview error boundary caught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorState
          description={
            this.state.error?.message ||
            "Failed to load preview. Please refresh the page."
          }
        />
      );
    }

    return this.props.children;
  }
}

export default PreviewErrorBoundary;
